export default __webpack_public_path__ + "static/media/fix-price.7e3aff95.svg";